import React, { Component } from "react";

export default class TheImageInput extends Component {
  render() {
    return (
      <div
        className="col-sm-8"
        style={{
          padding: "5px 12px 5px 12px",
        }}
      >
        <input
          type="file"
          accept="image/*"
          className=""
          id="attach_file"
          onChange={this.props.checkFiles}
          disabled={this.props.isDisabled}
        />
      </div>
    );
  }
}
